/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect } from "react";
import Validation from "../../../../../utils/validation";
import AccountName from "../../../../_utils/AccountCreationComponents/AccountName";
import ContactDetails from "../../../../_utils/AccountCreationComponents/ContactDetails";
import CommonLayout from "../../../../_utils/CommonLayout";

const TaxAccountStepContact = (props) => {
  const updatePayload = useCallback(
    (updates) => {
      props?.setPayload((prev) => ({ ...prev, ...updates }));
    },
    [props],
  );

  const updateAccountNameFrom = (type) => {
    if (type === "legalname") {
      const generated = props.payload.account_name_generated || "";

      props.setPayload((prev) => ({
        ...prev,
        account_name: generated,
      }));

      props.setAccountNameValidation(!!generated.trim());
      props.setSelectedValue("legalname");
      return;
    }

    if (type === "customname") {
      props.setSelectedValue("customname");

      const current = props.payload.account_name || "";
      props.setAccountNameValidation(!!current.trim());
      return;
    }
  };

  const suggestedName = props.payload.account_name;

  const handleRadioBtn = (e) => updateAccountNameFrom(e.target.value);
  const handleDivBtn = (value) => updateAccountNameFrom(value);

  const validateField = (name, value) => {
    let errors = { ...props?.customErrors };

    if (name === "email_id")
      errors = Validation.validateEmail(name, value, errors);

    if (name === "contact_no")
      errors = Validation.validateContactNum(name, value, errors);

    props?.setCustomErrors(errors);
  };

  const normalizeValue = (name, value) => {
    if (name === "account_name") return value.replace(/\s+/g, " ");
    return value.replace(/\s/g, "").trim();
  };

  const handleChange = (e) => {
    let { name, value } = e.target;
    value = normalizeValue(name, value);

    if (!Validation.allowedContactNum?.(value) && name === "contact_no") return;
    if (!Validation.allowedEmail?.(value) && name === "email_id") return;

    validateField(name, value);
    updatePayload({ [name]: value });

    if (name === "account_name") {
      if (!value.trim()) {
        props?.setAccountNameValidation(false);
        return;
      }

      props?.setAccountNameValidation(true);

      if (name === "account_name") {
        const trimmed = value.trim();

        props.setAccountNameValidation(!!trimmed);

        if (trimmed === props.payload.account_name_generated)
          props?.setSelectedValue("legalname");
        else props?.setSelectedValue("customname");
      }
    }
  };

  useEffect(() => {
    const contactOk =
      !props?.customErrors.contact_no &&
      props.payload.contact_no?.length === 10;

    const emailOk =
      !props?.customErrors.email_id &&
      props.payload.email_id &&
      Validation.emailRegex.test(props.payload.email_id);

    props?.setValidContact(contactOk);
    props?.setValidEmail(emailOk);
  }, [props?.customErrors, props.payload]);

  useEffect(() => {
    const nextState = {
      email: props?.validEmail,
      contact: props?.validContact,
      accountname: props.accountNameValidation,
    };

    props.parentCreateBen(nextState);
  }, [props?.validEmail, props?.validContact, props.accountNameValidation]);

  return (
    <div className="px-padding-md lg:px-padding-base  py-padding-md Qsmd:py-padding-base">
      <CommonLayout>
        <AccountName
          handleChange={handleChange}
          accountNameValidation={props.accountNameValidation}
          accountName={suggestedName}
          selectedValue={props.selectedValue}
          handleDivBtn={handleDivBtn}
          handleRadioBtn={handleRadioBtn}
          selectedRadioValue={props.selectedValue}
          legalName={"Suggested name"}
          placeHolder={"Account name"}
          userName={props.payload.userName}
          nameSubLabel="Autogenerate account name"
        />

        <ContactDetails
          handleChange={handleChange}
          contactNumberValidation={props?.validContact}
          emailValidation={props?.validEmail}
          contactNumber={props.payload.contact_no}
          emailId={props.payload.email_id}
          selectedValue={props.selectedValue}
        />
      </CommonLayout>
    </div>
  );
};

export default TaxAccountStepContact;
